import { characters } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Characters() {
  return (
    <section id="characters" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="角色一览"
          title="先认清人，再看故事怎么转"
          desc="人物关系是理解这部作品的关键。下面几位是全篇出场较多、对主线影响较大的角色。"
        />

        <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-6">
          {characters.map((person) => (
            <article
              key={person.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
            >
              <div className="h-44 w-full overflow-hidden bg-background-200 md:h-48">
                <img
                  src={person.cover}
                  alt={`${person.name}（${person.role}）角色形象`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                  {person.name}
                </h3>
                <p className="mt-1 font-label text-xs text-accent-700">{person.role}</p>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {person.desc}
                </p>
                <ul className="mt-3 flex flex-wrap gap-1.5">
                  {person.tags.map((tag) => (
                    <li
                      key={tag}
                      className="rounded-full bg-accent-100 px-2 py-0.5 font-label text-[11px] text-accent-900"
                    >
                      {tag}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}